import React, { useState, useEffect } from "react";

import "../assets/css/team.scss";

import LeftSideEditProfile from "./../LeftSideEditProfile";
import { Title } from "./../videoPhoto/Component";
import messagePopup from "../../../../../../utils/messagePopup";
import VerificationIcon from "./../assets/img/complete-verification-icon.svg";
import FormControl from "@mui/material/FormControl";
import { MenuItem, Select } from "@mui/material";
import AutoCompleteCitySearch from "../../../../../common/AutoCompleteCitySearch";
import {connect, useDispatch, useSelector} from "react-redux";
import swal from "sweetalert";
import {
  saveSchoolQuery,
  saveTeamQuery,
  getSchoolAndTeamTypesQuery,
  getLatestTeam,
  getLatestSchoolQuery,
  saveSchoolTeamMapping,
} from "./TeamQuery";
import { useHistory, useParams } from "react-router-dom";
import { userAcademicSchoolStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/academicSchool";
import {
  allTeamsListsaveStart,
  allTeamsListStart,
} from "../../../../../../redux/athlete/dashboard/editUserProfile/allTeams";
import { getUserInfo } from "../../../../../../services/authService";
import { schoolAndTeamListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/schoolAndTeamType";
import { fetchGraphMethod } from "../../../../../../services/httpService";
import { Link } from 'react-router-dom'

const selectStyle = {
  position: "relative",
  fontSize: "0.875rem",
  fontWeight: 400,
  color: "#3e3e3e",
  lineHeight: 1.4,
  marginBottom: "10px"
}

const SubHeader = ({ onSideMenuClick }) => {
  return (
    <div className="subHeader">
      <div className="menu">
        <button onClick={onSideMenuClick}>
          <span></span> Edit Profile
        </button>
      </div>
      {JSON.parse(localStorage.getItem('user')).verifiedUserStatus === 1 ? 
      <div className="profile-verified-text">
                   <span className="verifiedIcon">
                   <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26.418"
                          height="26.403"
                          viewBox="0 0 26.418 26.403"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                            transform="translate(4244.209 6690.181)"
                          />
                        </svg>
                        </span>
        Congrats your profile is verified
      </div>  
      :<div className="profile-verified-text">
        <img
          className="icon"
          src={VerificationIcon}
          alt="Verified"
        />
        Your profile is not verified for college coaches.
        <a style={{"cursor":"pointer"}} onClick={()=>window.open('https://calendly.com/sportsforce/recruiting-assessment-round-robin','_blank')}>Complete Verification Now</a>
      </div>}
      <div className="save">
        {/* <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.889"
            height="13.945"
            viewBox="0 0 13.889 13.945"
          >
            <g id="save" transform="translate(0 -0.001)">
              <path
                id="Path_2125"
                data-name="Path 2125"
                d="M13.38,2.1,11.793.508A1.736,1.736,0,0,0,10.565,0H9.548V3.038a.434.434,0,0,1-.434.434H2.17a.434.434,0,0,1-.434-.434V0H.868A.868.868,0,0,0,0,.868V13.021a.868.868,0,0,0,.868.868H13.021a.868.868,0,0,0,.868-.868v-9.7A1.736,1.736,0,0,0,13.38,2.1ZM12.153,12.153H1.736V6.944H12.153Z"
                transform="translate(0 0.058)"
                fill="#3e3e3e"
              />
              <rect
                id="Rectangle_416"
                data-name="Rectangle 416"
                width="2"
                height="3"
                transform="translate(5.457 0.001)"
                fill="#3e3e3e"
              />
            </g>
          </svg>
          Save
        </button> */}
      </div>
    </div>
  );
};

const EditSection = (props) => {
  // const { name, cityName } = useParams();
  const name = localStorage.getItem("teamName"),
      cityName = localStorage.getItem('teamCity');
  const [teamFields, setTeamFields] = useState({
    Id: "",
    sName: !!name ? name : "",
    city: parseInt(cityName) ? "" : cityName ? cityName : "",
    state: "",
    TypeId: 0,
    types: "",
    isLatest: "",
  });
  let history = useHistory();
  const [errors, setErrors] = useState({});

  //  validations
  const handleValidation = (fieldname, e) => {
    let errorsT = errors;
    let formIsValid = true;
    let fieldValue = e ? (e.target ? e.target.value : e) : e;
    let updatedValue = fieldValue;
    //sName validations
    if (fieldname === undefined || fieldname === "sName") {
      if (fieldname === undefined) {
        fieldValue = teamFields["sName"] ? teamFields["sName"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["sName"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["sName"] = "Please enter a school or team name.";
      }
    }
    //type validation
    if (fieldname === undefined || fieldname === "TypeId") {
      if (fieldname === undefined) {
        fieldValue = teamFields["TypeId"] ? teamFields["TypeId"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["TypeId"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["TypeId"] = "Please select type";
      }
    }
    //city validation
    if (fieldname === undefined || fieldname === "city") {
      if (fieldname === undefined) {
        fieldValue = teamFields["city"] ? teamFields["city"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["city"];
      if (!updatedValue.trim()) {
        formIsValid = false;
        errorsT["city"] = "Please enter city, state";
      }
    }
    setErrors({
      ...errorsT,
    });
    return {
      formIsValid,
      updatedValue,
    };
  };

  const handleChange = (field, e) => {
    e.preventDefault();
    setErrors({
      errorsT: "",
    });
    let fieldsT = teamFields;
    fieldsT[field] = e ? (e.target ? e.target.value : e) : e;
    setTeamFields({ ...fieldsT });
  };

  //Save School Function
  const saveSchoolData = async (e) => {
    if (
      teamFields.sName != "" ||
      teamFields.city != "" ||
      (teamFields.state != "" && teamFields.TypeId != "")
    ) {
      let variables =
        teamFields.Id == ""
          ? {
              obj: {
                userid: getUserInfo() ? getUserInfo().id : 0,
                highschoolname: teamFields.sName,
                city: teamFields.city,
                state: teamFields.state,
                typeid: parseInt(teamFields.TypeId),
              },
            }
          : {
              obj: {
                id: teamFields.Id,
                userid: getUserInfo() ? getUserInfo().id : 0,
                highschoolname: teamFields.sName,
                city: teamFields.city,
                state: teamFields.state,
                typeid: parseInt(teamFields.TypeId),
              },
            };
      let res = await fetchGraphMethod(saveSchoolQuery, variables, true);
      if (res.data.data.saveAthleteschool != null) {
        let id = res.data.data.saveAthleteschool.id;
        saveSchoolTeamUserMapping(true, id);
      } else {
        messagePopup("", "School  with same name already exists. Not available " +
            "in search section due to pending verification", "warning");
      }
    }
  };

  //Save Team function
  const saveTeamData = async () => {
    if (
      teamFields.sName != "" ||
      teamFields.city != "" ||
      (teamFields.state != "" && teamFields.TypeId != "")
    ) {
      let variables =
        teamFields.Id == ""
          ? {
              obj: {
                userid: getUserInfo() ? getUserInfo().id : 0,
                teamname: teamFields.sName,
                city: teamFields.city,
                state: teamFields.state,
                teamtypeid: parseInt(teamFields.TypeId),
              },
            }
          : {
              obj: {
                id: teamFields.Id,
                userid: getUserInfo() ? getUserInfo().id : 0,
                teamname: teamFields.sName,
                city: teamFields.city,
                state: teamFields.state,
                teamtypeid: parseInt(teamFields.TypeId),
              },
            };
      let res = await fetchGraphMethod(saveTeamQuery, variables, true);
      if (
        res.data.data &&
        res.data.data.saveTeam &&
        res.data.data.saveTeam.id
      ) {
        let id = res.data.data.saveTeam.id;
        saveSchoolTeamUserMapping(false, id);
      } else {
        if ('errors' in res?.data){
          //now showing msg from backend
          messagePopup("",!!res?.data?.errors?.[0]?.message?.msg ? res?.data?.errors?.[0]?.message?.msg :
              "Team  with same name already exists. Not available in search section " +
              "due to pending verification.", "warning");
        }
      }
    }
  };

  const checkIsLatestSchoolAndTeam = () => {
    if((!!teamFields?.sName) &&
        ((!!teamFields?.city ) || (!!teamFields?.state)) &&
        (!!teamFields?.TypeId)){
      const schoolListArray = props.SchoolData
          ? props.SchoolData.slice(-1)
          : null;

      const teamListArray = props.TeamData ? props.TeamData.slice(-1) : null;
      if (
          (schoolListArray != ""
              && schoolListArray[0].islatest === 1
          ) ||
          (teamListArray != ""
              && teamListArray[0].islatest === 1
          )
      ) {
        if (schoolListArray != "" && schoolListArray[0].islatest === 1) {
          swal({
            text: "You are required to send email request to coach for already added record",
            icon: "warning",
            buttons: {
              confirm: {text: "Ok"},
              cancel: "Cancel",
            },
            dangerMode: true,
          }).then((okay) => {
            if (okay) {
              history.push({
                pathname: "/add-coaches",
                state: {
                  schoolTeamMapping: {
                    isUserMapping: false,
                    isSchool: schoolListArray != "",
                    isTeam: false,
                    schoolid: schoolListArray != "" ? schoolListArray[0].id : null,
                    teamid: null,
                    previousPage: props
                  },
                },
              });
            }
          });
        }
        if (teamListArray != "" && teamListArray[0].islatest === 1) {
          swal({
            text: "You are required to send email request to coach for already added record",
            icon: "warning",
            buttons: {
              confirm: {text: "Ok"},
              cancel: "Cancel",
            },
            dangerMode: true,
          }).then((okay) => {
            if (okay) {
              history.push({
                pathname: "/add-coaches",
                state: {
                  schoolTeamMapping: {
                    isUserMapping: false,
                    isSchool: false,
                    isTeam: teamListArray != "",
                    schoolid: null,
                    teamid: teamListArray != "" ? teamListArray[0].id : null,
                    previousPage: props
                  },
                },
              });
            }
          });
        }
      } else {
        if (teamFields.types === 0) {
          saveSchoolData();
        } else {
          saveTeamData();
        }
      }
    }else{
      swal({text:"All Fields Are Mandatory", icon:"warning"})
    }
  }
  const saveSchoolTeamUserMapping = async (isSchool, id) => {
    let variables = {
      obj: {
        userid: getUserInfo().id,
        teamid: isSchool ? null : id,
        schoolid: isSchool ? id : null,
        createdby: getUserInfo().id
      },
    };
    let res = await fetchGraphMethod(saveSchoolTeamMapping, variables, true);
    if (res.data.data.saveSchoolteamusermapping != null) {
      history.push({
        pathname: "/add-coaches",
        state: {
          schoolTeamMapping: {
            isUserMapping: true,
            userMappingid: res.data.data.saveSchoolteamusermapping.id,
            isSchool: isSchool,
            isTeam: !isSchool,
            schoolid: isSchool ? id : null,
            teamid: isSchool ? null : id,
            previousPage: props?.saveData?.location?.previousPage || ""
          },
        },
      });
      messagePopup(
        "",
        isSchool === true ? "School " + "saved successfully." : "Team " + "saved successfully.",
        "success"
      );
    } else {
      messagePopup(
        "",
        isSchool === true ? "School " + "data not saved successfully.": "Team " + "data not saved successfully.",
        "warning"
      );
    }
  };
  //Save Function
  const handleSave = (e) => {
    e.preventDefault();
    // const { formIsValid } = handleValidation();
    // if (formIsValid) {
      checkIsLatestSchoolAndTeam();
    // }
  };

  //Set City and State in TeamFields
  const getAddress = (value) => {
    let fieldsT = teamFields;
    fieldsT["city"] = value.city;
    //below code is when state is having null/"" so to over come this
    fieldsT["state"] = !!value.state ? value.state : value?.country ;
    setTeamFields({ ...fieldsT });
  };

  const getTypes = () => {
    const Data = !!props.schoolAndTeamType
      ? props?.schoolAndTeamType.filter((item) => item?.id === teamFields?.TypeId)
      : "";
    const fields = teamFields;
    fields["types"] = !!Data ? Data[0]?.type : "";
    setTeamFields({ ...fields });
  };

  return (
    <div className="editSection">
      <Title title={"Teams"} />
      <div className="check-list-sec">
        <div className="editprofile-common-form team-common-form">
          <form className="">
            <h3>Find Your Team</h3>
            <div className="fieldBox flexBox align-items-start">
              <div className="half">
                <label>Team name <sup>*</sup></label>
                <input
                  type="text"
                  placeholder="Enter Team Name"
                  value={teamFields.sName}
                  onChange={(e) => handleChange("sName", e)}
                  required
                />
                <div className="error">{errors["sName"]}</div>
              </div>

              <div className="half">
                <label>City, State / Province <sup>*</sup></label>
                <div className={"searchLocation contactPage"}>
                  <AutoCompleteCitySearch
                    addressDetails={getAddress}
                    cityName={teamFields.city}
                    required
                  />
                   <div className="error">{errors["city"]}</div>
                </div>
              </div>
            </div>
            <div className="fieldBox full">
              <div style={selectStyle}>Team Type <sup>*</sup></div>
              <FormControl variant="outlined" fullWidth>
                <Select
                  // labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={teamFields.TypeId}
                  onChange={(e) => {
                    handleChange("TypeId", e);
                    getTypes();
                  }}
                  // label="Select"
                  displayEmpty
                >
                  <MenuItem value={0}>
                    <em>None</em>
                  </MenuItem>
                  {props.schoolAndTeamType
                    ? props.schoolAndTeamType.map((Item, idx) => (
                        <MenuItem key={idx} value={Item.id}>
                          {Item.name}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
              <div className="error">{errors["TypeId"]}</div>
            </div>

            <div className="invite-coach-wrap">
              <div className="button-box">
                <Link className="btn orange"
                      // href="#/teams/add-team"
                    onClick={(e)=>{
                      history.push({
                        pathname:'/teams/add-team',

                      })
                    }}
                >
                  Back
                </Link>
                <a
                  className="btn green"
                  onClick={(e) => {
                    handleSave(e);
                  }}
                >
                  Next
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const TeamForm = (props) => {
  const store = useSelector(store => store)
  const [sideMenuOpen, setSideMenu] = useState(store?.athlete?.editUserProfileData?.teamSideBarStatus?.status || false);
  const dispatch = useDispatch()
  const onSideMenuClick = () => {
    setSideMenu(!sideMenuOpen);
    dispatch({type:"TEAM_SIDE_BAR_START" ,payload:{status: !sideMenuOpen}})
  };

  useEffect(() => {
    getAllSchoolList();
    getAllTeams();
    props.schoolAndTeamListStart({
      query: getSchoolAndTeamTypesQuery,
      variables: {
        where:{
          type: 1
        }
      },
    });
  }, []);

  const getAllSchoolList = () => {
    props.userAcademicSchoolStart({
      query: getLatestSchoolQuery,
      variables: {
        obj: {
          userid: getUserInfo ? getUserInfo().id : null,
          active: 1,
          //this is added for specific for team
          isuserschool: 0
        },
      },
    });
  };

  const getAllTeams = () => {
    props.allTeamsListStart({
      query: getLatestTeam,
      variables: {
        obj: {
          userid: getUserInfo ? getUserInfo().id : null,
          active: 1,
        },
      },
    });
  };
  //func is used for scrolling the page on top
useEffect(()=>{
  setTimeout(()=>{
    window.scrollTo(0,0)
  },1800)
},[])
  return (
    <div className="pageContent">
      <div className="editProfile">
        <div className="container">
          <div
            id="wrapper"
            className={`flex ${sideMenuOpen ? "inactive" : ""}`}
          >
            <SubHeader onSideMenuClick={onSideMenuClick} />
            <div className="sidebar">
              <LeftSideEditProfile />
            </div>
            <EditSection
              saveData={props}
              schoolAndTeamType={
                props.schoolAndTeamList.data &&
                props.schoolAndTeamList.data.schoolAndTeams
                  ? props.schoolAndTeamList.data.schoolAndTeams
                  : null
              }
              TeamData={
                props.allTeamList &&
                props.allTeamList.data &&
                props.allTeamList.data.allTeamsList
                  ? props.allTeamList.data.allTeamsList
                  : null
              }
              SchoolData={
                props.allSchoolDetails &&
                props.allSchoolDetails.data &&
                props.allSchoolDetails.data.allUserAcademicSchool &&
                props.allSchoolDetails.data.allUserAcademicSchool.Athleteschools
                  ? props.allSchoolDetails.data.allUserAcademicSchool
                      .Athleteschools
                  : null
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allTeamList: state.athlete.editUserProfileData.teamsList,
    allSchoolDetails: state.athlete.editUserProfileData.userAcademicSchool,
    schoolAndTeamList: state.athlete.editUserProfileData.schoolAndTeamTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    allTeamsListStart: (data) => dispatch(allTeamsListStart(data)),
    userAcademicSchoolStart: (data) => dispatch(userAcademicSchoolStart(data)),
    schoolAndTeamListStart: (data) => dispatch(schoolAndTeamListStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamForm);
